import { useEffect } from "react";
import "../../styles/Contents.css";

export default function Notes() {
  useEffect(() => {
    const elements = document.querySelectorAll(
      ".reveal, .reveal-left, .reveal-right"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else {
            entry.target.classList.remove("active");
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="page">

      {/* HERO */}
      <section className="about-hero reveal">
        <h1>Our Notes</h1>
        <p>
          Thoughtfully designed study notes that simplify learning,
          strengthen concepts, and improve academic performance.
        </p>
      </section>

      {/* QUALITY SECTION */}
      <section className="about-section reveal-left">
        <div className="about-text">
          <h2>Why Our Notes Stand Out</h2>
          <p>
            Our notes are prepared by experienced faculty with a strong
            focus on clarity, accuracy, and syllabus alignment. Every topic
            is explained in a structured manner to ensure easy understanding
            for students of Classes 8, 9, and 10.
          </p>
          <p>
            We emphasize conceptual learning rather than rote memorization,
            helping students build a solid foundation that supports both
            school exams and competitive preparation.
          </p>
        </div>
      </section>

      {/* HIGHLIGHTS */}
      <section className="mission-section reveal-right">
        <h2>Key Features of Our Notes</h2>

        <div className="mission-grid reveal">
          <div className="mission-card">
            <h3>📘 Syllabus Aligned</h3>
            <p>
              Fully aligned with CBSE and State board syllabus to ensure
              relevance and exam readiness.
            </p>
          </div>

          <div className="mission-card">
            <h3>🧠 Concept-Focused</h3>
            <p>
              Clear explanations with step-by-step breakdowns to strengthen
              core concepts.
            </p>
          </div>

          <div className="mission-card">
            <h3>✍️ Exam-Oriented</h3>
            <p>
              Important points, definitions, and examples highlighted for
              quick revision.
            </p>
          </div>
        </div>
      </section>

      {/* FOOTER NOTE */}
      <section className="about-footer reveal">
        <p>
          Our notes are regularly updated to reflect syllabus changes and
          evolving exam patterns, ensuring students always study the
          most relevant material.
        </p>
      </section>

    </div>
  );
}
